import { getAdminApiUrl } from '@adsk/acs-sc-web-platform-api';
import { PRODUCT_IDS } from '@adsk/alloy-provider';
import { getConstructionApiUrl, USER_ACCOUNT_OFFERING_TYPES } from '@adsk/acs-admin-ui-components-helpers';
export var buildProjectTypesRequest = function buildProjectTypesRequest(accountId) {
  return "".concat(getAdminApiUrl(), "/v1/accounts/").concat(accountId, "/project-types?limit=200");
};
export var buildCreateAccountCompanyRequest = function buildCreateAccountCompanyRequest(accountId, companyData) {
  return ["".concat(getAdminApiUrl(), "/v1/accounts/").concat(accountId, "/companies"), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(companyData)
  }];
};
export var buildGetAccountUsersRequest = function buildGetAccountUsersRequest(_ref) {
  var accountId = _ref.accountId,
    search = _ref.search,
    includeAllMembers = _ref.includeAllMembers,
    _ref$searchByEmailsAr = _ref.searchByEmailsArray,
    searchByEmailsArray = _ref$searchByEmailsAr === void 0 ? false : _ref$searchByEmailsAr,
    fields = _ref.fields,
    _ref$equalTextMatch = _ref.equalTextMatch,
    equalTextMatch = _ref$equalTextMatch === void 0 ? false : _ref$equalTextMatch;
  var buildedGetAccountUsersUrl = "".concat(getAdminApiUrl(), "/v1/accounts/").concat(accountId, "/users?limit=200");
  if (equalTextMatch) {
    buildedGetAccountUsersUrl = "".concat(buildedGetAccountUsersUrl, "&filterTextMatch=equals");
  }
  if (search) {
    var encodedSearch = encodeURIComponent(search);
    buildedGetAccountUsersUrl = searchByEmailsArray ? "".concat(buildedGetAccountUsersUrl, "&filter[emails]=").concat(encodedSearch) : "".concat(buildedGetAccountUsersUrl, "&filter[email]=").concat(encodedSearch);
  }
  if (includeAllMembers) {
    buildedGetAccountUsersUrl = "".concat(buildedGetAccountUsersUrl, "&filter[status]=not_invited,pending,disabled,active");
  }
  if (fields) {
    buildedGetAccountUsersUrl = "".concat(buildedGetAccountUsersUrl, "&fields=").concat(fields);
  }
  return buildedGetAccountUsersUrl;
};
export var buildAccountDataRequest = function buildAccountDataRequest(accountId) {
  return "".concat(getAdminApiUrl(), "/v1/accounts/").concat(accountId);
};
export var buildGetAccountUserOfferingsRequest = function buildGetAccountUserOfferingsRequest(accountId, userId) {
  return "".concat(getAdminApiUrl(), "/v1/accounts/").concat(accountId, "/users/").concat(userId, "/offerings");
};
export var buildGetAccountOfferingsRequest = function buildGetAccountOfferingsRequest(accountId) {
  return "".concat(getAdminApiUrl(), "/v1/accounts/").concat(accountId, "/offerings");
};
export var buildGetProjectRequest = function buildGetProjectRequest(projectId) {
  return "".concat(getConstructionApiUrl(), "/v1/projects/").concat(projectId);
};
export var getUserSubscriptionsProducts = function getUserSubscriptionsProducts(userOfferings) {
  var userSubscriptions = userOfferings.filter(function (offering) {
    return offering.type !== USER_ACCOUNT_OFFERING_TYPES.NONE;
  });
  return userSubscriptions.reduce(function (result, subscription) {
    var subscriptionProducts = subscription.products;
    subscriptionProducts.forEach(function (product) {
      if (product.included && (product.userAssignable || product.type === PRODUCT_IDS.INSIGHT) && !result.some(function (r) {
        return r.type === product.type;
      })) result.push(product);
    });
    return result;
  }, []);
};
//# sourceMappingURL=utils.js.map